// ----------------------------------------------------------------------

export const _id = [...Array(40)].map(
  (_, index) => `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index + 1}`
);

export const _fullAddress = [
  '19034 Verna Unions Apt. 164 - Honolulu, RI / 87535',
  '1147 Rohan Drive Suite 819 - Burlington, VT / 82021',
  '18605 Thompson Circle Apt. 086 - Idaho Falls, WV / 50337',
  '110 Lamar Station Apt. 730 - Hagerstown, OK / 49808',
  '36901 Elmer Spurs Apt. 762 - Miramar, DE / 92836',
  '2089 Runolfsson Harbors Suite 886 - Chapel Hill, TX / 32827',
  '279 Karolann Ports Apt. 774 - Prescott Valley, WV / 53905',
  '96607 Claire Square Suite 591 - St. Louis Park, HI / 40802',
  '9388 Auer Station Suite 573 - Honolulu, AK / 98024',
  '47665 Adaline Squares Suite 510 - Blacksburg, NE / 53515',
  '989 Vernice Flats Apt. 183 - Billings, NV / 04147',
  '91020 Wehner Locks Apt. 673 - Albany, WY / 68763',
  '585 Candelario Pass Suite 090 - Columbus, LA / 25376',
  '80988 Renner Crest Apt. 000 - Fargo, VA / 24266',
  '28307 Shayne Pike Suite 523 - North Las Vegas, AZ / 28550',
  '205 Farrell Highway Suite 333 - Rock Hill, OK / 63421',
  '253 Kara Motorway Suite 821 - Manchester, SD / 09331',
  '13663 Kiara Oval Suite 606 - Missoula, AR / 44478',
  '8110 Claire Port Apt. 703 - Anchorage, TN / 01753',
  '4642 Demetris Lane Suite 407 - Edmond, AZ / 60888',
  '74794 Asha Flat Suite 890 - Lancaster, OR / 13466',
  '8135 Keeling Pines Apt. 326 - Alexandria, MA / 89442',
  '441 Gibson Shores Suite 247 - Pasco, NM / 60678',
  '4373 Emelia Valley Suite 596 - Columbia, NM / 42586'
];

// ----------------------------------------------------------------------

export const _booleans = [
  true,
  true,
  true,
  false,
  false,
  true,
  false,
  false,
  false,
  false,
  true,
  true,
  true,
  false,
  false,
  false,
  true,
  false,
  false,
  false,
  true,
  false,
  false,
  true
];

// ----------------------------------------------------------------------

export const _emails = [
  'nannie_abernathy70@yahoo.com',
  'ashlynn_ohara62@gmail.com',
  'milo.farrell@hotmail.com',
  'violet.ratke86@yahoo.com',
  'letha_lubowitz24@yahoo.com',
  'aditya_greenfelder31@gmail.com',
  'lenna_bergnaum27@hotmail.com',
  'luella.ryan33@gmail.com',
  'joana.simonis84@gmail.com',
  'marjolaine_white94@gmail.com',
  'vergie_block82@hotmail.com',
  'vito.hudson@hotmail.com',
  'tyrel_greenholt@gmail.com',
  'dwight.block85@yahoo.com',
  'mireya13@hotmail.com',
  'dasia_jenkins@hotmail.com',
  'benny89@yahoo.com',
  'dawn.goyette@gmail.com',
  'zella_hickle4@yahoo.com',
  'avery43@hotmail.com',
  'olen_legros@gmail.com',
  'jimmie.gerhold73@hotmail.com',
  'genevieve.powlowski@hotmail.com',
  'louie.kuphal39@gmail.com'
];

// ----------------------------------------------------------------------

export const _fullNames = [
  'Jayvion Simon',
  'Lucian Obrien',
  'Deja Brady',
  'Harrison Stein',
  'Reece Chung',
  'Lainey Davidson',
  'Cristopher Cardenas',
  'Melanie Noble',
  'Chase Day',
  'Shawn Manning',
  'Soren Durham',
  'Cortez Herring',
  'Brycen Jimenez',
  'Giana Brandt',
  'Aspen Schmitt',
  'Colten Aguilar',
  'Angelique Morse',
  'Selina Boyer',
  'Lawson Bass',
  'Ariana Lang',
  'Amiah Pruitt',
  'Harold Mcgrath',
  'Esperanza Mcintyre',
  'Mireya Conner'
];

export const _firstNames = [
  'Mossie',
  'David',
  'Ebba',
  'Chester',
  'Eula',
  'Jaren',
  'Boyd',
  'Brady',
  'Aida',
  'Anastasia',
  'Gregoria',
  'Julianne',
  'Ila',
  'Elyssa',
  'Lucio',
  'Lewis',
  'Jacinthe',
  'Molly',
  'Brown',
  'Fritz',
  'Keon',
  'Ella',
  'Ken',
  'Whitney'
];

export const _lastNames = [
  'Carroll',
  'Simonis',
  'Yost',
  'Hand',
  'Emmerich',
  'Wilderman',
  'Howell',
  'Sporer',
  'Boehm',
  'Morar',
  'Koch',
  'Reynolds',
  'Padberg',
  'Watsica',
  'Upton',
  'Yundt',
  'Pfeffer',
  'Parker',
  'Zulauf',
  'Treutel',
  'McDermott',
  'McDermott',
  'Cruickshank',
  'Parisian'
];

// ----------------------------------------------------------------------

export const _prices = [
  83.74, 97.14, 68.71, 85.21, 52.17, 25.18, 43.84, 60.98, 98.42, 53.37, 72.75,
  56.61, 64.55, 77.32, 60.62, 79.81, 93.68, 47.44, 76.24, 92.87, 72.91, 20.54,
  94.25, 37.51
];

export const _ratings = [
  4.2, 3.7, 4.5, 3.5, 0.5, 3.0, 2.5, 2.8, 4.9, 3.6, 2.5, 1.7, 3.9, 2.8, 4.1,
  4.5, 2.2, 3.2, 0.6, 1.3, 3.8, 3.8, 3.8, 2.0
];

export const _ages = [
  30, 26, 59, 47, 29, 46, 18, 56, 39, 19, 45, 18, 46, 56, 38, 41, 44, 48, 32,
  45, 42, 60, 33, 57
];

export const _percents = [
  10.1, 13.6, 28.2, 42.1, 37.2, 18.5, 40.1, 94.8, 91.4, 53.0, 25.4, 62.9, 86.6,
  62.4, 35.4, 17.6, 52.0, 6.8, 95.3, 26.6, 69.9, 92.1, 46.2, 85.6
];

export const _nativeS = [
  11, 10, 7, 10, 12, 5, 10, 1, 8, 8, 10, 11, 12, 8, 4, 11, 8, 9, 4, 9, 2, 6, 3,
  7
];

export const _nativeM = [
  497, 763, 684, 451, 433, 463, 951, 194, 425, 435, 807, 521, 538, 839, 394,
  269, 453, 821, 364, 849, 804, 776, 263, 239
];

export const _nativeL = [
  9911, 1947, 9124, 6984, 8488, 2034, 3364, 8401, 8996, 5271, 8478, 1139, 8061,
  3035, 6733, 3952, 2405, 3127, 6843, 4672, 6995, 6053, 5192, 9686
];

// ----------------------------------------------------------------------

export const _phoneNumbers = [
  '365-374-4961',
  '904-966-2836',
  '399-757-9909',
  '692-767-2903',
  '990-588-5716',
  '955-439-2578',
  '226-924-4058',
  '552-917-1454',
  '285-840-9338',
  '306-269-2446',
  '883-373-6253',
  '476-509-8866',
  '201-465-1954',
  '538-295-9408',
  '531-492-6028',
  '981-699-7588',
  '500-268-4826',
  '205-952-3828',
  '222-255-5190',
  '408-439-8033',
  '272-940-8266',
  '812-685-8057',
  '353-801-5212',
  '606-285-8928'
];

// ----------------------------------------------------------------------

export const _roles = [
  'HR Manager',
  'Data Analyst',
  'Legal Counsel',
  'UX/UI Designer',
  'Project Manager',
  'Account Manager',
  'Registered Nurse',
  'Business Analyst',
  'Creative Director',
  'Financial Planner',
  'Event Coordinator',
  'Marketing Director',
  'Software Developer',
  'Research Scientist',
  'Content Strategist',
  'Operations Manager',
  'Sales Representative',
  'Supply Chain Analyst',
  'Operations Coordinator',
  'Customer Service Associate',
  'Quality Assurance Specialist',
  'CEO',
  'CFO',
  'CTO'
];

// ----------------------------------------------------------------------

export const _postTitles = [
  '10 Essential Tips for Healthy Living',
  'The Ultimate Guide to Productivity Hacks',
  'Exploring the Hidden Gems of [Destination]',
  'How to Master the Art of Public Speaking',
  'The Future of Artificial Intelligence: Trends and Insights',
  'Delicious Recipes for a Vegan Diet',
  "A Beginner's Guide to Investing in Stocks",
  'The Impact of Social Media on Society',
  '10 Must-Visit Destinations for Adventure Travelers',
  'The Benefits of Mindfulness Meditation',
  'The Importance of Mental Health Awareness',
  'Building a Strong Personal Brand: Tips and Strategies',
  '10 Effective Strategies for Digital Marketing Success',
  'Unveiling the Secrets of Successful Entrepreneurs',
  'The Rise of Remote Work and its Impact on the Workforce',
  'The Art of Landscape Photography: Techniques and Inspiration',
  'Understanding Blockchain Technology and its Potential Applications',
  'How to Create Engaging Content for Social Media',
  'The Role of Artificial Intelligence in Healthcare',
  '10 Home Organization Hacks for a Clutter-Free Space',
  'Exploring the History and Culture of [City/Region]',
  'The Power of Positive Thinking: Transform Your Mindset',
  'The Influence of Music on Mood and Emotions',
  'Travel Photography Tips: Capturing Memories Around the World'
];

// ----------------------------------------------------------------------

export const _productNames = [
  'Nike Air Force 1 NDESTRUKT',
  'Foundations Matte Flip Flop',
  'Nike Air Zoom Pegasus 37 A.I.R. Chaz Bear',
  'Arizona Soft Footbed Sandal',
  'Boston Soft Footbed Sandal',
  'Zoom Freak 2',
  'Gazelle Vintage low-top sneakers',
  'Jordan Delta',
  'Air Jordan XXXV PF',
  'Rod Laver low-top sneakers',
  'Kyrie 7 EP Sisterhood',
  'Pharrell Williams Human Race NMD sneakers',
  'Nike Blazer Low 77 Vintage',
  'ASMC Winter Boot Cold.Rdy',
  'ZX 8000 Lego sneakers',
  'Ultraboost 21 sneakers',
  '2750 Cotu Classic Sneaker',
  'ZX 9000 A-ZX Series sneakers',
  'Madrid Big Buckle Sandal',
  'Chuck 70 Hi Sneaker',
  'Relaxed Adjustable Strap Slingback Sandal',
  'Superturf Adventure X Atmos',
  'Chuck Taylor All Star Lift Sneaker',
  'Run Star Hike Platform Sneaker'
];

// ----------------------------------------------------------------------

export const _tourNames = [
  'Adventure Seekers Expedition',
  'Historic Heritage Tour',
  'Culinary Delights Exploration',
  "Nature's Wonders Escapade",
  'Cultural Immersion Journey',
  'Wildlife Safari Expedition',
  "Urban Explorer's City Tour",
  'Coastal Paradise Getaway',
  'Wine Tasting Experience',
  'Spiritual Retreat Tour',
  'Outdoor Adventure Trek',
  'Photography Expedition',
  'Music and Arts Discovery Tour',
  'Wellness and Yoga Retreat',
  'Hidden Gems Discovery Tour',
  'Volcano and Geothermal Exploration',
  "Foodie's Gastronomic Tour",
  'Hiking and Camping Adventure',
  'Architecture and Design Tour',
  'Coastal Cruise and Island Hopping',
  'Scenic Train Ride Experience',
  'Historical Landmarks Expedition',
  'Surfing and Beach Adventure',
  'Nightlife and Entertainment Tour'
];

// ----------------------------------------------------------------------

export const _jobTitles = [
  'Software Engineer',
  'Marketing Manager',
  'Financial Analyst',
  'Graphic Designer',
  'Sales Representative',
  'Project Manager',
  'Data Scientist',
  'Human Resources Coordinator',
  'Accountant',
  'Customer Service Representative',
  'Nurse',
  'Product Manager',
  'Operations Manager',
  'Social Media Specialist',
  'Business Development Executive',
  'Content Writer',
  'Web Developer',
  'Electrical Engineer',
  'Research Scientist',
  'Legal Assistant',
  'Chef',
  'Financial Planner',
  'Architect',
  'Event Planner'
];

// ----------------------------------------------------------------------

export const _companyNames = [
  'Lueilwitz and Sons',
  'Gleichner, Mueller and Tromp',
  'Nikolaus - Leuschke',
  'Hegmann, Kreiger and Bayer',
  'Grimes Inc',
  'Durgan - Murazik',
  'Altenwerth, Medhurst and Roberts',
  'Raynor Group',
  'Mraz, Donnelly and Collins',
  'Padberg - Bailey',
  'Heidenreich, Stokes and Parker',
  'Pagac and Sons',
  'Rempel, Hand and Herzog',
  'Dare - Treutel',
  'Kihn, Marquardt and Crist',
  'Nolan - Kunde',
  'Wuckert Inc',
  'Dibbert Inc',
  'Goyette and Sons',
  'Feest Group',
  'Bosco and Sons',
  'Bartell - Kovacek',
  'Schimmel - Raynor',
  'Tremblay LLC'
];

// ----------------------------------------------------------------------

export const _tags = [
  'Technology',
  'Marketing',
  'Design',
  'Photography',
  'Art',
  'Fashion',
  'Food',
  'Travel',
  'Fitness',
  'Nature',
  'Business',
  'Music',
  'Health',
  'Books',
  'Sports',
  'Film',
  'Education',
  'Motivation',
  'Gaming',
  'Pets',
  'Cooking',
  'Finance',
  'Selfcare',
  'Writing'
];

// ----------------------------------------------------------------------

export const _taskNames = [
  'Complete Project Proposal',
  'Conduct Market Research',
  'Design User Interface Mockups',
  'Develop Backend API',
  'Implement Authentication System',
  'Write Test Cases',
  'Perform Database Optimization',
  'Create Content Marketing Plan',
  'Update Website Copy',
  'Conduct A/B Testing',
  'Create Social Media Graphics',
  'Optimize Website Performance',
  'Review Competitor Websites',
  'Implement Payment Gateway Integration',
  'Conduct User Acceptance Testing',
  'Prepare Monthly Sales Report',
  'Enhance SEO Strategy',
  'Conduct Customer Satisfaction Survey',
  'Design Email Newsletter Template',
  'Monitor Server Logs for Errors',
  'Create Training Materials',
  'Plan and Execute Marketing Campaign',
  'Develop Mobile Application',
  'Coordinate Project Meetings'
];

// ----------------------------------------------------------------------

export const _sentences = [
  'The sun slowly set over the horizon, painting the sky in vibrant hues of orange and pink.',
  'She eagerly opened the gift, her eyes sparkling with excitement.',
  'The old oak tree stood tall and majestic, its branches swaying gently in the breeze.',
  'The aroma of freshly brewed coffee filled the air, awakening my senses.',
  'The children giggled with joy as they ran through the sprinklers on a hot summer day.',
  'He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.',
  'The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.',
  'The waves crashed against the shore, creating a soothing symphony of sound.',
  'The scent of blooming flowers wafted through the garden, creating a fragrant paradise.',
  'She gazed up at the night sky, marveling at the twinkling stars that dotted the darkness.',
  'The professor delivered a captivating lecture, engaging the students with thought-provoking ideas.',
  'The hiker trekked through the dense forest, guided by the soft glow of sunlight filtering through the trees.',
  'The delicate butterfly gracefully fluttered from flower to flower, sipping nectar with its slender proboscis.',
  'The aroma of freshly baked cookies filled the kitchen, tempting everyone with its irresistible scent.',
  "The majestic waterfall cascaded down the rocks, creating a breathtaking display of nature's power.",
  'The actor delivered a powerful performance, moving the audience to tears with his emotional portrayal.',
  'The book transported me to a magical world, where imagination knew no bounds.',
  'The scent of rain filled the air as dark clouds gathered overhead, promising a refreshing downpour.',
  'The chef skillfully plated the dish, turning simple ingredients into a work of culinary art.',
  'The newborn baby let out a tiny cry, announcing its arrival to the world.',
  'The athlete sprinted across the finish line, arms raised in victory as the crowd erupted in applause.',
  'The ancient ruins stood as a testament to a civilization long gone, their grandeur still awe-inspiring.',
  'The artist dipped the brush into vibrant paint, bringing the canvas to life with bold strokes and vivid colors.',
  'The laughter of children echoed through the playground, filling the atmosphere with pure joy.'
];

// ----------------------------------------------------------------------

export const _descriptions = [
  `Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.`,
  `Atque eaque ducimus minima distinctio velit. Laborum et veniam officiis. Delectus ex saepe hic id laboriosam officia. Odit nostrum qui illum saepe debitis ullam. Laudantium beatae modi fugit ut. Dolores consequatur beatae nihil voluptates rem maiores.`,
  `Rerum eius velit dolores. Explicabo ad nemo quibusdam. Voluptatem eum suscipit et ipsum et consequatur aperiam quia. Rerum nulla sequi recusandae illum velit quia quas. Et error laborum maiores cupiditate occaecati.`,
  `Et non omnis qui. Qui sunt deserunt dolorem aut velit cumque adipisci aut enim. Nihil quis quisquam nesciunt dicta nobis ab aperiam dolorem repellat. Voluptates non blanditiis. Error et tenetur iste soluta cupiditate ratione perspiciatis et. Quibusdam aliquid nam sunt et quisquam non esse.`,
  `Nihil ea sunt facilis praesentium atque. Ab animi alias sequi molestias aut velit ea. Sed possimus eos. Et est aliquid est voluptatem.`,
  `Non rerum modi. Accusamus voluptatem odit nihil in. Quidem et iusto numquam veniam culpa aperiam odio aut enim. Quae vel dolores. Pariatur est culpa veritatis aut dolorem.`,
  `Est enim et sit non impedit aperiam cumque animi. Aut eius impedit saepe blanditiis. Totam molestias magnam minima fugiat.`,
  `Unde a inventore et. Sed esse ut. Atque ducimus quibusdam fuga quas id qui fuga.`,
  `Eaque natus adipisci soluta nostrum dolorem. Nesciunt ipsum molestias ut aliquid natus ut omnis qui fugiat. Dolor et rem. Ut neque voluptatem blanditiis quasi ullam deleniti.`,
  `Nam et error exercitationem qui voluptate optio. Officia omnis qui accusantium ipsam qui. Quia sequi nulla perspiciatis optio vero omnis maxime omnis ipsum. Perspiciatis consequuntur asperiores veniam dolores.`,
  `Perspiciatis nulla ut ut ut voluptates totam consectetur eligendi qui. Optio ut cum. Dolorum sapiente qui laborum. Impedit temporibus totam delectus nihil. Voluptatem corrupti rem.`,
  `Distinctio omnis similique omnis eos. Repellat cumque rerum nisi. Reiciendis soluta non ut veniam temporibus. Accusantium et dolorem voluptas harum. Nemo eius voluptate dicta et hic nemo. Dolorem assumenda et beatae molestias sit quo mollitia quis consequatur.`,
  `Sed ut mollitia tempore ipsam et illum doloribus ut. Occaecati ratione veritatis explicabo. Omnis nam omnis sunt placeat tempore accusantium placeat distinctio velit.`,
  `Eum illo dicta et perspiciatis ut blanditiis eos sequi. Ea veritatis aut et voluptas aut. Laborum eos quia tempore a culpa.`,
  `Aut quos quae dolores repudiandae similique perferendis perferendis earum laudantium. Facere placeat natus nobis. Eius vitae ullam dolorem.`,
  `Vero dolorem et voluptatem fugit tempore a quam iure. Fuga consequatur corrupti sunt asperiores vitae. Libero totam repellendus animi debitis illum et sunt officia.`,
  `Cupiditate illum officiis id molestiae. Numquam non molestiae aliquid et natus sed hic. Alias quia explicabo sed corrupti sint. Natus in et odio qui unde facilis quia. Est sit eius laboriosam aliquid non aperiam quia quo corporis.`,
  `Et a ab. Optio aspernatur minus tempora amet vitae consectetur inventore cumque. Sed et omnis. Aspernatur a magnam.`,
  `Ipsum omnis et. Quia ea et autem tempore consequuntur veniam dolorem officiis. Ipsa dicta et ut quidem quia doloremque. Sequi vitae doloremque temporibus. Deserunt incidunt id aperiam itaque natus. Earum sit eaque quas incidunt nihil.`,
  `Quae consequatur reiciendis. Consequatur non optio. Eaque id placeat. Commodi quo officia aut repudiandae reiciendis tempore voluptatem et. Ut accusamus qui itaque maxime aliquam. Fugit ut animi molestiae porro maiores.`,
  `Modi hic asperiores ab cumque quam est aut. Voluptas atque quos molestias. Ut excepturi distinctio ipsam aspernatur sit.`,
  `Sunt totam facilis. Quam commodi voluptatem veniam. Tempora deleniti itaque fugit nihil voluptas.`,
  `Ipsam aliquam velit nobis repellendus officiis aut deserunt id et. Nihil sunt aut dolores aut. Dolores est ipsa quia et laborum quidem laborum accusamus id. Facilis odit quod hic laudantium saepe omnis nisi in sint. Sed cupiditate possimus id.`,
  `Magnam non eveniet optio optio ut aliquid atque. Velit libero aspernatur quis laborum consequatur laudantium. Tempora facere optio fugit accusantium ut. Omnis aspernatur reprehenderit autem esse ut ut enim voluptatibus.`
];

// ----------------------------------------------------------------------

export const _department_name = [
  'Physical Therapy',
  'Pathology',
  'Obstetrics and Gynecology',
  'Otorhinolaryngology',
  'Radiology',
  'Immunology',
  'Cardiology',
  'Urology',
  'General Surgery',
  'Ophthalmology',
  'Internal Medicine',
  'Surgery',
  'Pediatrics',
  'Emergency Medicine',
  'Anesthesiology',
  'Family Medicine',
  'Dermatology',
  'Psychiatry',
  'Neurology'
];
// ----------------------------------------------------------------------

export const _cost_center = [
  '1001',
  '1002',
  '1003',
  '1004',
  '1005',
  '1006',
  '1007',
  '1008',
  '1009',
  '1010',
  '1011',
  '1012',
  '1013',
  '1014',
  '1015',
  '1016',
  '1017',
  '1018',
  '1019'
];

// ----------------------------------------------------------------------

export const _parent_department_name = [
  'Rehabilitation Services',
  'Laboratory Services',
  "Women's Health",
  'Surgical Services',
  'Diagnostic Services',
  'Laboratory Services',
  'Heart Center',
  'Surgical Services',
  'Surgical Services',
  'Surgical Services',
  'Medicine',
  'Surgical Services',
  "Children's Health",
  'Emergency Services',
  'Surgical Services',
  'Primary Care',
  'Skin and Cosmetic Services',
  'Behavioral Health',
  'Brain and Nerve Center'
];
// ----------------------------------------------------------------------

export const _application_name = [
  'Billing and Insurance Software',
  'Clinical Decision Support System',
  'Compliance Management Software',
  'Electronic Medical Records System',
  'Health Information Exchange Platform',
  'Inventory Management System',
  'Laboratory Information Management System',
  'Mobile Health Application',
  'Patient Management Software',
  'Patient Portal',
  'Pharmacy Management System',
  'Radiology Information System',
  'Surgical Scheduling System',
  'Telehealth Platform'
];
// ----------------------------------------------------------------------

export const _app_support_cost = [
  '7000250',
  '9500400',
  '8300345',
  '12000500',
  '9800410',
  '7200290',
  '8500350',
  '5000200',
  '8000300',
  '6500275',
  '7800310',
  '9000375',
  '8100340',
  '6000200'
];
// ----------------------------------------------------------------------

export const _app_service_cost = [
  '4500125',
  '7000320',
  '6100285',
  '8000250',
  '7400330',
  '5400240',
  '6500280',
  '3000150',
  '5000150',
  '4700235',
  '5600260',
  '6800295',
  '5900275',
  '4000100'
];
// ----------------------------------------------------------------------

export const _app_license_cost = [
  '11000000',
  '22000000',
  '19000000',
  '20000000',
  '23000000',
  '16000000',
  '18000000',
  '8000000',
  '15000000',
  '14000000',
  '17000000',
  '19500000',
  '17500000',
  '12000000'
];
// ----------------------------------------------------------------------

export const _app_ftes_cost = [
  '9000000',
  '16000000',
  '15000000',
  '15000000',
  '17000000',
  '12000000',
  '14000000',
  '6000000',
  '10000000',
  '11000000',
  '13000000',
  '14500000',
  '13500000',
  '8000000'
];
// ----------------------------------------------------------------------

export const _app_hosting_onprem_cost = [
  '2500000',
  '5500000',
  '5100000',
  '5000000',
  '5800000',
  '4400000',
  '4800000',
  '2000000',
  '3000000',
  '4000000',
  '4600000',
  '5200000',
  '4700000',
  '2000000'
];
// ----------------------------------------------------------------------

export const _app_license_renewal_cost = [
  '6000000',
  '11000000',
  '9200000',
  '10000000',
  '11500000',
  '8500000',
  '9000000',
  '4000000',
  '8000000',
  '7000000',
  '8800000',
  '9500000',
  '8900000',
  '5000000'
];
// ----------------------------------------------------------------------

export const _app_server_upgrade_cost = [
  '3500000',
  '8000000',
  '7000000',
  '7500000',
  '8500000',
  '6300000',
  '6800000',
  '3000000',
  '4000000',
  '5500000',
  '6500000',
  '7200000',
  '6600000',
  '3000000'
];
// ----------------------------------------------------------------------

export const _app_license_renewal_date = [
  new Date('Nov  5 2024'),
  new Date('May 20 2025'),
  new Date('Nov 20 2025'),
  new Date('Jun 15 2025'),
  new Date('Oct 15 2024'),
  new Date('Jul 30 2025'),
  new Date('Feb 15 2025'),
  new Date('Apr 10 2025'),
  new Date('Dec 20 2024'),
  new Date('Aug  5 2025'),
  new Date('Jan 25 2025'),
  new Date('Sep 10 2024'),
  new Date('Dec 30 2024'),
  new Date('Mar 10 2025')
];
// ----------------------------------------------------------------------

export const _fiscal_year =
  // [...Array(11)].map((_, index) => `${new Date().getFullYear() + index}`)
  [
    '2024',
    '2025',
    '2026',
    '2027',
    '2028',
    '2029',
    '2030',
    '2031',
    '2032',
    '2033'
  ];
// [
//   '2023',
//   '2022',
//   '2021',
//   '2020',
//   '2019',
//   '2018',
//   '2017',
//   '2016',
//   '2015',
//   '2014',
//   '2013',
//   '2012',
//   '2011',
//   '2010',
// ];
// ----------------------------------------------------------------------

export const _opex_budget = [
  '87654321',
  '123456789',
  '156789012',
  '98765432',
  '134567890',
  '109876543',
  '176543210',
  '145678901',
  '189012345',
  '165432109',
  '123098765',
  '154321098',
  '132109876',
  '178901234'
];
// ----------------------------------------------------------------------

export const _capex_budget = [
  '127543210',
  '198765432',
  '145678901',
  '312345678',
  '254321098',
  '287654321',
  '165432109',
  '378901234',
  '234567890',
  '189012345',
  '345678901',
  '201234567',
  '256789012',
  '321098765'
];
// ----------------------------------------------------------------------

export const _network_cost = [
  '530765',
  '612489',
  '754201',
  '589342',
  '673821',
  '501987',
  '837465',
  '725634',
  '568210',
  '654302',
  '721908',
  '589765',
  '803146',
  '567890'
];
// ----------------------------------------------------------------------

export const _it_staff_budget = [
  '721543',
  '589123',
  '634987',
  '876201',
  '512340',
  '743689',
  '590123',
  '678901',
  '832456',
  '567890',
  '701234',
  '623987',
  '745312',
  '598765'
];
// ----------------------------------------------------------------------

export const _support_cost_type = [
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx'
];
// ----------------------------------------------------------------------

export const _service_cost_type = [
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx'
];
// ----------------------------------------------------------------------

export const _license_cost_type = [
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx',
  'CapEx',
  'OpEx'
];
// ----------------------------------------------------------------------

export const _project_name = [
  'Quantum Byte',
  'Cyber Sphere',
  'Data Nexa',
  'Inno Tech Hub',
  'Code Fleet',
  'Cloud Vortex',
  'Pixel Forge',
  'Secure Linker',
  'Mind Mesh',
  'Nano Glide',
  'Digi Pulse',
  'Tech Fusion X',
  'Byte Burst',
  'Quantum Logic'
];
// ----------------------------------------------------------------------

export const _project_description = [
  'Revolutionizing data storage with cutting-edge quantum computing technology.',
  'Enhancing cybersecurity measures through advanced threat detection and prevention.',
  'A data analytics platform for extracting valuable insights and optimizing decision-making.',
  'Fostering innovation by providing a collaborative space for technology enthusiasts.',
  'Agile software development platform for efficient and rapid code deployment.',
  'Seamless cloud integration for scalable and flexible computing solutions.',
  'Creative digital design and development studio specializing in pixel-perfect solutions.',
  'Building secure connections and protecting data integrity through advanced encryption.',
  'Cognitive computing platform for harnessing the power of artificial intelligence.',
  'Microservices architecture for building lightweight and efficient applications.',
  'Pioneering digital transformation with a focus on real-time data connectivity.',
  'Integrating diverse technologies to create synergistic and innovative solutions.',
  'Accelerating data transfer and processing speed with optimized byte-level operations.',
  'Implementing logical operations in quantum computing for unparalleled computational power.'
];
// ----------------------------------------------------------------------

export const _project_budget = [
  '1250000',
  '750000',
  '2500000',
  '1800000',
  '1100000',
  '900000',
  '3200000',
  '1600000',
  '2300000',
  '1350000',
  '2000000',
  '1450000',
  '1750000',
  '2800000'
];
// ----------------------------------------------------------------------

export const _req_ftes = [
  '2',
  '1',
  '3',
  '2',
  '1',
  '3',
  '2',
  '1',
  '3',
  '2',
  '1',
  '3',
  '2',
  '2'
];
// ----------------------------------------------------------------------

export const _ftes_inclusive = [
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false
];
// ----------------------------------------------------------------------

export const _ftes_cost = [
  '43250',
  '27800',
  '36100',
  '20500',
  '48200',
  '15000',
  '31000',
  '42000',
  '11800',
  '49300',
  '27500',
  '46800',
  '12600',
  '36800'
];
// ----------------------------------------------------------------------

export const _project_fiscal_years = [
  '3',
  '4',
  '2',
  '1',
  '5',
  '3',
  '4',
  '2',
  '1',
  '5',
  '3',
  '4',
  '2',
  '1'
];
// ----------------------------------------------------------------------

export const _project_year = [
  '2003',
  '2012',
  '2026',
  '2007',
  '2019',
  '2023',
  '2002',
  '2030',
  '2010',
  '2021',
  '2005',
  '2029',
  '2008',
  '2017'
];
// ----------------------------------------------------------------------

export const _project_fy_budget = [
  '1300000',
  '2100000',
  '1850000',
  '1500000',
  '950000',
  '2400000',
  '1800000',
  '2000000',
  '1200000',
  '2200000',
  '1700000',
  '1650000',
  '2300000',
  '2000000'
];
// ----------------------------------------------------------------------

export const _server_list = [
  'Ubuntu Server',
  'CentOS',
  'Windows Server 2019',
  'FreeBSD',
  'Amazon Linux',
  'Debian',
  'Red Hat Enterprise Linux (RHEL)',
  'Fedora Server',
  'openSUSE',
  'Arch Linux',
  'SUSE Linux Enterprise Server (SLES)',
  'VMware ESXi',
  'Proxmox Virtual Environment (Proxmox VE)',
  'Alibaba Cloud Linux'
];
// ----------------------------------------------------------------------

export const _server_version = [
  'Ubuntu Server 20.04',
  'CentOS 8',
  'Windows Server 2019',
  'FreeBSD 12.2',
  'Amazon Linux 2',
  'Debian 10',
  'Red Hat Enterprise Linux (RHEL) 8',
  'Fedora Server 33',
  'openSUSE Leap 15.2',
  'Arch Linux 2022.03.01',
  'SUSE Linux Enterprise Server (SLES) 15',
  'VMware ESXi 7.0',
  'Proxmox Virtual Environment (Proxmox VE) 7',
  'Alibaba Cloud Linux 2.1903'
];
// ----------------------------------------------------------------------

export const _soc2 = [
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false
];
// ----------------------------------------------------------------------

export const _server_supported = [
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false,
  true,
  false
];
// ----------------------------------------------------------------------

export const _server_next_refresh = [
  new Date('Nov  5 2024'),
  new Date('May 20 2025'),
  new Date('Nov 20 2025'),
  new Date('Jun 15 2025'),
  new Date('Oct 15 2024'),
  new Date('Jul 30 2025'),
  new Date('Feb 15 2025'),
  new Date('Apr 10 2025'),
  new Date('Dec 20 2024'),
  new Date('Aug  5 2025'),
  new Date('Jan 25 2025'),
  new Date('Sep 10 2024'),
  new Date('Dec 30 2024'),
  new Date('Mar 10 2025')
];
// ----------------------------------------------------------------------

export const _server_name = [
  'Nginx',
  'Apache HTTP Server',
  'Microsoft IIS',
  'MySQL Server',
  'PostgreSQL',
  'MongoDB',
  'Redis',
  'Elasticsearch',
  'Docker',
  'Kubernetes',
  'Jenkins',
  'GitLab',
  'WordPress',
  'Node.js'
];

// ----------------------------------------------------------------------
export const _server_last_patch = [
  new Date('Nov 5 2022'),
  new Date('May 20 2019'),
  new Date('Nov 20 2020'),
  new Date('Jun 15 2020'),
  new Date('Oct 15 2020'),
  new Date('Jul 30 2019'),
  new Date('Feb 15 2020'),
  new Date('Apr 10 2020'),
  new Date('Dec 20 2020'),
  new Date('Aug 5 2019'),
  new Date('Jan 25 2020'),
  new Date('Sep 10 2018'),
  new Date('Dec 30 2019'),
  new Date('Mar 10 2020')
];

// ----------------------------------------------------------------------
export const _app_quality_application_name = [
  'QuantumSphere',
  'CyberNexus',
  'DataVortex',
  'TechHarbor',
  'SwiftSync',
  'InnoForge',
  'PulseGuard',
  'NexaPlex',
  'CogniSys',
  'SparkFlow',
  'VirtuHub',
  'IntelliSync',
  'CyberPulse',
  'EvoLink'
];

// ----------------------------------------------------------------------
export const _app_quality_db_size = [
  '2.3',
  '1.7',
  '3.2',
  '0.5',
  '4.5',
  '2.1',
  '2.8',
  '4.0',
  '1.2',
  '2.6',
  '4.2',
  '5',
  '2.9',
  '3.7',
  '2.6'
];

// ----------------------------------------------------------------------
export const _app_quality_total_size = [
  '6.7',
  '7.5',
  '5.8',
  '6.2',
  '7.8',
  '5.5',
  '6.1',
  '5.0',
  '7.3',
  '5.6',
  '6.4',
  '8',
  '7.2',
  '5.9',
  '5.5'
];

// ----------------------------------------------------------------------
export const _app_quality_audit_log = [
  '4',
  '1',
  '3',
  '2',
  '5',
  '1',
  '4',
  '2',
  '3',
  '5',
  '1',
  '2',
  '4',
  '3',
  '2'
];

// ----------------------------------------------------------------------
export const _app_quality_comments = [
  'Enhanced user experience, minimal downtime',
  'Essential for financial transactions, robust reliability',
  'Recently patched, security vulnerabilities addressed',
  'Manages customer billing information securely',
  'Integral to supply chain management, real-time updates',
  'Regularly monitored for compliance, limited user access',
  'Cloud-based, optimized for scalability and speed',
  'Handles confidential client communications seamlessly',
  'Central hub for project collaboration, high availability',
  'Utilizes cutting-edge encryption for data protection',
  'Streamlines HR processes, accurate payroll calculations',
  'Supports multiple integrations, seamless interoperability',
  'Crucial for inventory management, low error rate',
  'Geographically redundant, disaster recovery in place',
  'Regularly monitored for compliance, limited user access'
];

// ----------------------------------------------------------------------
export const _app_quality_frequency = [
  '1',
  '1.5',
  '3.5',
  '0.5',
  '3.5',
  '4.5',
  '5',
  '2',
  '3.5',
  '0.5',
  '3.5',
  '4.5',
  '5',
  '2'
];

// ----------------------------------------------------------------------
export const _app_quality_expansion = [
  '3',
  '2',
  '5',
  '1',
  '4',
  '2',
  '1',
  '5',
  '3',
  '4',
  '2',
  '1',
  '3',
  '5'
];

// ----------------------------------------------------------------------
export const _app_quality_training = [
  '2',
  '4',
  '1',
  '3',
  '5',
  '2',
  '1',
  '4',
  '3',
  '5',
  '1',
  '2',
  '4',
  '3'
];

// ----------------------------------------------------------------------
export const _app_quality_bi = [
  true,
  false,
  false,
  true,
  false,
  true,
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  true
];

// ----------------------------------------------------------------------
export const _app_quality_revenue = [
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  true,
  true,
  false,
  false,
  true,
  false,
  true
];

// ----------------------------------------------------------------------
export const _app_quality_growth = [
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  true,
  false,
  false,
  true,
  false,
  true,
  true
];

// ----------------------------------------------------------------------
export const _app_quality_uniqueness = [
  '1',
  '1.5',
  '3.5',
  '0.5',
  '3.5',
  '4.5',
  '5',
  '2',
  '3.5',
  '0.5',
  '3.5',
  '4.5',
  '5',
  '2'
];

// ----------------------------------------------------------------------
export const _app_quality_stability = [
  '3',
  '5',
  '1',
  '2',
  '4',
  '1',
  '4',
  '3',
  '2',
  '5',
  '1',
  '3',
  '2',
  '4'
];

// ----------------------------------------------------------------------
export const _app_quality_maintenance = [
  '2',
  '5',
  '1',
  '4',
  '3',
  '2',
  '5',
  '1',
  '3',
  '4',
  '1',
  '2',
  '4',
  '3'
];

// ----------------------------------------------------------------------
export const _app_quality_outage_impact = [
  '5',
  '1',
  '4',
  '2',
  '3',
  '5',
  '1',
  '3',
  '2',
  '4',
  '1',
  '4',
  '3',
  '2'
];

// ----------------------------------------------------------------------
export const _app_quality_value = [
  '4',
  '3',
  '2',
  '5',
  '1',
  '3',
  '2',
  '4',
  '1',
  '5',
  '2',
  '3',
  '1',
  '4'
];

// ----------------------------------------------------------------------
export const _app_quality_sole_source = [
  true,
  false,
  false,
  true,
  false,
  true,
  false,
  false,
  true,
  false,
  true,
  false,
  false,
  true
];

// ----------------------------------------------------------------------
export const _app_quality_redundancy = [
  '3',
  '2',
  '4',
  '1',
  '5',
  '1',
  '3',
  '2',
  '4',
  '5',
  '1',
  '2',
  '4',
  '3'
];
